// import './App.css';
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import { Outlet } from 'react-router-dom';
import React from "react";
import { ModalProvider } from './ModalContext.js';
import FirstModal from './Components/Model/FirstModal';
import SecondModal from './Components/Model/SecondModal';
import ThirdModal from './Components/Model/ThirdModal';
// import { Helmet } from 'react-helmet';
function App() {


  return (
    <>
      <ModalProvider>
        <FirstModal />
        <SecondModal />
        <ThirdModal />
        <Header />
        <Outlet />
        <Footer />
      </ModalProvider>
    </>
  );
}

export default App;
